import axios from "axios";

try {
  var store = require("@/store/store").default;
} catch (err) {
  try {
    var store = require("@/framework/store/store").default;
  } catch (err) {}
}

try {
  var rest = require("@/services/pagews").default;
} catch (err) {
  try {
    var rest = require("@/framework/services/pagews").default;
  } catch (err) {}
}

import md5, { base64 } from "js-md5";
export default () => {
  let $return = axios.create({
    baseURL: global.config.endpoint,
    headers: {
      Authorization: `Bearer ${store.state.token}`
    },
    withCredentials: true
  });

  $return.interceptors.request.use(
    function(config) {
      // Do something before request is sent
      let s = new Date().getTime();
      let diffurl = config.url.replace(config.baseURL, "");
      if (diffurl.substr(0, 1) != "/") diffurl = "/" + diffurl;
      if (diffurl.endsWith("?"))
        diffurl = diffurl.substr(0, diffurl.length - 1);
      let wsj = md5(
        atob("am50b2sxMjNoYXNtZDUkI0A=") +
          s +
          JSON.stringify(config.data) +
          diffurl
      );
      config.headers[atob("V3NqdGs=")] = s + "-" + wsj;

      return config;
    },
    function(error) {
      // Do something with request error
      return Promise.reject(error);
    }
  );

  return $return;
};
/* eslint-disable */
const serialize = function(obj) {
  var str = [];
  for (var p in obj)
    if (obj.hasOwnProperty(p)) {
      str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
    }
  return str.join("&");
};

const myCnvStr = function(str) {
  let b = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  let a = "FLoWGSmQIe6Vp4lN9aDynYOr0TkK1MBib73CZERqXsh5Pz2fxHtuAwg8cdUJjv";
  let ab = {};
  for (var l = 0; l < a.length; l++) {
    ab[a.charAt(l)] = b.charAt(l);
  }
  let str2 = "";
  for (var i = 0; i < str.length; i++) {
    let vc = ab[str.charAt(i)];
    str2 += vc !== undefined ? vc : str.charAt(i);
  }
  return str2;
};

let preloadcache = {};
global.express = {
  call: async (
    path = "",
    mode = "get",
    query = null,
    post = null,
    ondata = null
  ) => {
    let ret = (await rest.load(path, mode, query, post, ondata)).data;
    if (ret != null && ret.datares) {
      ret = Buffer.from(myCnvStr(ret.datares), "base64").toString();
      ret = JSON.parse(ret);
    }

    return ret;
  },

  meta: async (path, param = {}, ondata = null) => {
    preloadcache = {};
    let ret = (
      await rest.load("pagemeta/obj", "post", { path: path }, param, ondata)
    ).data;

    if (ret != null && ret.datares) {
      ret = Buffer.from(myCnvStr(ret.datares), "base64").toString();
      ret = JSON.parse(ret);
    }

    if (ret._extras) {
      for (let x in ret._extras) {
        if (typeof preloadcache[x] === "function") {
          let callback = preloadcache[x];
          preloadcache[x] = ret._extras[x];
          callback(preloadcache[x]);
        } else {
          preloadcache[x] = ret._extras[x];
        }
      }
    }

    return ret;
  },
  metawait: (path, param = null) => {
    if (param != null) {
      let pmd5 = serialize(param);
      path += ":" + pmd5;
    }

    return new Promise((callback, reject) => {
      if (preloadcache[path]) {
        return callback(preloadcache[path]);
      }
      preloadcache[path] = callback;
    });
  }
};
